import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Banner() {
  const [live, setLive] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/settings/public`)
      .then((r) => {
        if (r.data.launch_date && new Date(`${r.data.launch_date}T09:00:00`).getTime() <= Date.now()) {
          setLive(true);
        }
      })
      .catch(() => {});
  }, []);

  if (live) {
    return (
      <div
        className="bg-forest text-center text-xs sm:text-sm font-medium px-4 py-2.5 leading-relaxed"
        data-testid="live-banner"
      >
        <span className="text-honey">🐝 ApiaryKeeper is LIVE — full launch is here! </span>
        <Link
          to="/"
          data-testid="live-banner-cta"
          className="text-bone underline underline-offset-2 font-semibold transition-colors duration-300 hover:text-honey"
        >
          Download now.
        </Link>
      </div>
    );
  }

  return (
    <div
      className="bg-honey text-forest text-center text-xs sm:text-sm font-medium px-4 py-2.5 leading-relaxed"
      data-testid="beta-banner"
    >
      🐝 ApiaryKeeper is currently in Beta — Full launch coming soon!{" "}
      <Link
        to="/pre-register?src=banner"
        data-testid="beta-banner-cta"
        className="underline underline-offset-2 font-semibold transition-colors duration-300 hover:text-forest-deep"
      >
        Join the Launch List for early access.
      </Link>
    </div>
  );
}
